import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import LogOut from "./../components/LogOut";

import editnumber from "../assets/pen-number.png";
import trashicon from "../assets/trash.png";

import { API_URL } from "../config/api";

const MONTHLY_REPORTS_API = `http://backend.goldensection.agency/public/api/monthly-reports`;

const MONTHS = [
  { value: "01", label: "يناير" },
  { value: "02", label: "فبراير" },
  { value: "03", label: "مارس" },
  { value: "04", label: "أبريل" },
  { value: "05", label: "مايو" },
  { value: "06", label: "يونيو" },
  { value: "07", label: "يوليو" },
  { value: "08", label: "أغسطس" },
  { value: "09", label: "سبتمبر" },
  { value: "10", label: "أكتوبر" },
  { value: "11", label: "نوفمبر" },
  { value: "12", label: "ديسمبر" },
];

const getEmptyForm = () => ({
  client_id: "",
  month: "",
  year: new Date().getFullYear(),
  pdf: null,
});

export default function AddCompleteReport() {
  const [clients, setClients] = useState([]);
  const [reports, setReports] = useState([]);

  const [showPopup, setShowPopup] = useState(false);
  const [editPopup, setEditPopup] = useState(null);

  const [form, setForm] = useState(getEmptyForm());

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [pdfPreview, setPdfPreview] = useState(null);

  // رسالة الحالة (نجاح / خطأ)
  const [statusMsg, setStatusMsg] = useState(null); // { type: "success"|"error", text }

  // فلتر
  const [filterClient, setFilterClient] = useState("");
  const [filterMonth, setFilterMonth] = useState("");

  // =========================
  // جلب العملاء
  // =========================
  useEffect(() => {
    fetchClients();
    fetchReports();
  }, []);

  const fetchClients = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(
        `http://backend.goldensection.agency/public/api/getuser`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      const data = await res.json();
      const list = Array.isArray(data) ? data : data.data || data.users || [];
      setClients(list);
    } catch (error) {
      console.error("خطأ في جلب العملاء:", error);
    }
  };

  // =========================
  // جلب التقارير
  // =========================
  const fetchReports = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const res = await fetch(MONTHLY_REPORTS_API, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        console.error("خطأ في جلب التقارير:", res.status, err);
        setReports([]);
        return;
      }

      const data = await res.json();
      const list = Array.isArray(data) ? data : data.data || data.reports || [];
      setReports(list);
    } catch (error) {
      console.error("خطأ في جلب التقارير:", error);
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // تغيير الفورم
  // =========================
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  // =========================
  // فتح Popup الإضافة
  // =========================
  const openAddPopup = () => {
    setForm(getEmptyForm());
    setPdfPreview(null);
    setEditPopup(null);
    setStatusMsg(null);
    setShowPopup(true);
  };

  // =========================
  // حفظ التقرير
  // =========================
  const handleSave = async () => {
    if (!form.client_id) {
      alert("اختر العميل أولاً");
      return;
    }
    if (!form.month) {
      alert("اختر الشهر");
      return;
    }
    if (!form.year) {
      alert("اختر السنة");
      return;
    }
    if (!editPopup && !form.pdf) {
      alert("اختر ملف PDF");
      return;
    }

    try {
      setSaving(true);
      setStatusMsg(null);

      const token = localStorage.getItem("token");

      const formData = new FormData();
      formData.append("client_id", form.client_id);
      formData.append("month", form.month);
      formData.append("year", form.year);
      if (form.pdf) formData.append("pdf", form.pdf);

      let res;

      if (!editPopup) {
        // ── إضافة ──
        res = await fetch(MONTHLY_REPORTS_API, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: formData,
        });
      } else {
        // ── تعديل ──
        res = await fetch(`${MONTHLY_REPORTS_API}/${editPopup}`, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: formData,
        });
      }

      const responseData = await res.json().catch(() => ({}));

      if (!res.ok) {
        // استخرج أول رسالة خطأ من Laravel validation
        let errMsg = responseData?.message || `خطأ ${res.status}`;
        if (responseData?.errors) {
          const firstField = Object.keys(responseData.errors)[0];
          errMsg = responseData.errors[firstField][0];
        }
        setStatusMsg({ type: "error", text: errMsg });
        return;
      }

      // نجاح
      setStatusMsg({
        type: "success",
        text: editPopup
          ? "تم تعديل التقرير بنجاح ✓"
          : "تم إضافة التقرير بنجاح ✓",
      });
      setShowPopup(false);
      setEditPopup(null);
      setForm(getEmptyForm());
      setPdfPreview(null);
      fetchReports();
    } catch (error) {
      console.error("خطأ في حفظ التقرير:", error);
      setStatusMsg({ type: "error", text: "حدث خطأ في الاتصال بالسيرفر" });
    } finally {
      setSaving(false);
    }
  };

  // =========================
  // فتح التعديل
  // =========================
  const openEdit = (report) => {
    setEditPopup(report.id);
    setForm({
      client_id: report.client_id || report.client?.id || "",
      month: report.month || "",
      year: report.year || new Date().getFullYear(),
      pdf: null,
    });
    setPdfPreview(null);
    setStatusMsg(null);
    setShowPopup(true);
  };

  // =========================
  // حذف
  // =========================
  const handleDelete = async (report) => {
    if (!window.confirm("هل أنت متأكد من حذف التقرير؟")) return;

    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${MONTHLY_REPORTS_API}/${report.id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        alert(err.message || "فشل حذف التقرير");
        return;
      }

      setStatusMsg({ type: "success", text: "تم حذف التقرير بنجاح" });
      fetchReports();
    } catch (error) {
      console.error("خطأ في حذف التقرير:", error);
      alert("حدث خطأ في الاتصال بالسيرفر");
    }
  };

  // =========================
  // إظهار / إخفاء
  // =========================
  const toggleVisibility = async (report) => {
    try {
      const token = localStorage.getItem("token");

      const formData = new FormData();
      formData.append("is_visible", report.is_visible ? "0" : "1");

      const res = await fetch(`${MONTHLY_REPORTS_API}/${report.id}`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        alert(err.message || "فشل تغيير حالة التقرير");
        return;
      }

      fetchReports();
    } catch (error) {
      console.error("خطأ في تغيير حالة التقرير:", error);
    }
  };

  // =========================
  // اسم العميل
  // =========================
  const getClientName = (report) => {
    if (report.client?.name) return report.client.name;
    const client = clients.find(
      (item) => String(item.id) === String(report.client_id),
    );
    return client?.name || "غير معروف";
  };

  // =========================
  // اسم الشهر
  // =========================
  const getMonthName = (month) => {
    const found = MONTHS.find(
      (item) => String(item.value) === String(month).padStart(2, "0"),
    );
    return found?.label || month;
  };

  return (
    <div className="seo-page">
      {/* Navbar */}
      <nav className="seo-navbar">
        <h1 className="nav-title">التقارير الشهرية</h1>
        <LogOut />
        <button className="add1">
          <Link to="/admin">العودة للرئيسية</Link>
        </button>
        <button className="add4" onClick={openAddPopup}>
          إضافة تقرير
        </button>
      </nav>

      {/* رسالة الحالة */}
      {statusMsg && (
        <div
          className={`status-banner ${statusMsg.type === "success" ? "status-success" : "status-error"}`}
          onClick={() => setStatusMsg(null)}
        >
          {statusMsg.text}
          <span className="status-close">×</span>
        </div>
      )}

      {/* ── شريط الفلتر ── */}
      <div className="admin-filter-bar">
        {/* فلتر العميل */}
        <div className="admin-filter-group">
          <label className="admin-filter-label">العميل</label>
          <select
            className="admin-filter-select"
            value={filterClient}
            onChange={(e) => setFilterClient(e.target.value)}
          >
            <option value="">كل العملاء</option>
            {clients.map((c) => (
              <option key={c.id} value={String(c.id)}>
                {c.name}
              </option>
            ))}
          </select>
        </div>

        {/* فلتر الشهر */}
        <div className="admin-filter-group">
          <label className="admin-filter-label">الشهر</label>
          <select
            className="admin-filter-select"
            value={filterMonth}
            onChange={(e) => setFilterMonth(e.target.value)}
          >
            <option value="">كل الشهور</option>
            {MONTHS.map((m) => (
              <option key={m.value} value={m.value}>
                {m.label}
              </option>
            ))}
          </select>
        </div>

        {/* زرار مسح الفلتر */}
        {(filterClient || filterMonth) && (
          <button
            className="admin-filter-clear"
            onClick={() => {
              setFilterClient("");
              setFilterMonth("");
            }}
          >
            <i className="fa-solid fa-xmark"></i> مسح الفلتر
          </button>
        )}
      </div>

      {/* Table */}
      <div className="admin_area">
        {/* ── تحديد التقارير المفلترة ── */}
        {(() => {
          const filtered = reports.filter((r) => {
            const matchClient =
              !filterClient ||
              String(r.client_id) === filterClient ||
              String(r.client?.id) === filterClient;
            const matchMonth =
              !filterMonth || String(r.month).padStart(2, "0") === filterMonth;
            return matchClient && matchMonth;
          });

          return (
            <table className="users-table monthly-reports-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>العميل</th>
                  <th>الشهر</th>
                  <th>التقرير</th>
                  <th>الحالة</th>
                  <th>الإجراءات</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="6" className="empty-table">
                      جاري تحميل التقارير...
                    </td>
                  </tr>
                ) : filtered.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="empty-table">
                      {reports.length === 0
                        ? "لا توجد تقارير شهرية حتى الآن"
                        : "لا توجد نتائج تطابق الفلتر المحدد"}
                    </td>
                  </tr>
                ) : (
                  filtered.map((report, index) => (
                    <tr key={report.id}>
                      {/* الرقم */}
                      <td>{index + 1}</td>

                      {/* العميل */}
                      <td>
                        <strong>{getClientName(report)}</strong>
                      </td>

                      {/* الشهر */}
                      <td>
                        <div className="report-month">
                          <strong>{getMonthName(report.month)}</strong>
                          <span>{report.year}</span>
                        </div>
                      </td>

                      {/* PDF */}
                      <td>
                        {report.pdf_url ? (
                          <a
                            href={report.pdf_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="pdf-button"
                          >
                            <i className="fa-solid fa-file-pdf"></i>
                            فتح التقرير
                          </a>
                        ) : (
                          <span style={{ color: "#aaa", fontSize: "13px" }}>
                            لا يوجد ملف
                          </span>
                        )}
                      </td>

                      {/* الحالة */}
                      <td>
                        <button
                          className={`visibility-toggle-btn ${report.is_visible ? "vis-on" : "vis-off"}`}
                          onClick={() => toggleVisibility(report)}
                          title={
                            report.is_visible
                              ? "اضغط لإخفاء التقرير عن العميل"
                              : "اضغط لإظهار التقرير للعميل"
                          }
                        >
                          {report.is_visible ? (
                            <>
                              <i className="fa-solid fa-eye"></i> ظاهر
                            </>
                          ) : (
                            <>
                              <i className="fa-solid fa-eye-slash"></i> مخفي
                            </>
                          )}
                        </button>
                      </td>

                      {/* الإجراءات */}
                      <td>
                        <div className="report-actions">
                          <button
                            className="delete-btn"
                            onClick={() => openEdit(report)}
                            title="تعديل"
                          >
                            <img src={editnumber} alt="edit" />
                          </button>
                          <button
                            className="delete-btn"
                            onClick={() => handleDelete(report)}
                            title="حذف"
                          >
                            <img src={trashicon} alt="delete" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          );
        })()}
      </div>

      {/* =========================
          Popup
      ========================= */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup monthly-report-popup">
            {/* Close */}
            <button
              className="cancel-btn"
              onClick={() => {
                setShowPopup(false);
                setEditPopup(null);
                setPdfPreview(null);
              }}
            >
              ×
            </button>

            <h3>{editPopup ? "تعديل التقرير الشهري" : "إضافة تقرير شهري"}</h3>

            {/* رسالة خطأ داخل البوبأب */}
            {statusMsg?.type === "error" && (
              <div className="popup-error-msg">{statusMsg.text}</div>
            )}

            {/* العميل */}
            <label>العميل</label>
            <select
              name="client_id"
              value={form.client_id}
              onChange={handleChange}
            >
              <option value="">-- اختر العميل --</option>
              {clients.map((client) => (
                <option key={client.id} value={client.id}>
                  {client.name}
                </option>
              ))}
            </select>

            {/* الشهر */}
            <label>الشهر</label>
            <select name="month" value={form.month} onChange={handleChange}>
              <option value="">-- اختر الشهر --</option>
              {MONTHS.map((month) => (
                <option key={month.value} value={month.value}>
                  {month.label}
                </option>
              ))}
            </select>

            {/* السنة */}
            <label>السنة</label>
            <input
              type="number"
              name="year"
              value={form.year}
              onChange={handleChange}
              min="2020"
              max="2100"
            />

            {/* PDF */}
            <label>
              {editPopup ? "استبدال ملف PDF - اختياري" : "ملف التقرير PDF"}
            </label>

            <input
              type="file"
              name="pdf"
              accept="application/pdf,.pdf"
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (!file) {
                  setForm((prev) => ({ ...prev, pdf: null }));
                  setPdfPreview(null);
                  return;
                }
                if (file.type !== "application/pdf") {
                  alert("من فضلك اختر ملف PDF فقط");
                  e.target.value = "";
                  return;
                }
                setForm((prev) => ({ ...prev, pdf: file }));
                setPdfPreview(URL.createObjectURL(file));
              }}
            />

            {pdfPreview && (
              <div className="pdf-upload-preview">
                <div className="pdf-preview-title">
                  <span>معاينة التقرير</span>
                  <button
                    type="button"
                    onClick={() => {
                      setPdfPreview(null);
                      setForm((prev) => ({ ...prev, pdf: null }));
                    }}
                  >
                    إزالة الملف
                  </button>
                </div>
                <iframe
                  src={pdfPreview}
                  title="PDF Preview"
                  className="pdf-upload-iframe"
                />
              </div>
            )}

            {editPopup && (
              <small className="pdf-note">
                اترك الملف فارغًا إذا كنت لا تريد تغيير التقرير الحالي.
              </small>
            )}

            {/* Save */}
            <button className="save-btn" onClick={handleSave} disabled={saving}>
              {saving ? "جاري الحفظ..." : "حفظ التقرير"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
